<template>
  <div>
      <!-- 头部 -->
      <headers></headers>
      <!-- 内容部分开始 -->
      <!-- 中文版 -->
    <div v-if="langluageType == 'ch'" class="index-main" id="index">
        <section class="ban">
            <div class="col">
                <div>
                    <h1 class="h1">
                        串联会展产业链各个关键环节<br>
                        共赢共建会展数字经济
                    </h1>
                    <a class="btn" href="about">了解详情</a>
                    <div class="line"></div>
                </div>
            </div>
        </section>

        <section class="box-2">
            <!-- <div class="box-2-bg">
                <div class="bg-top"></div>
                <div class="bg-bottom"></div>
            </div> -->
            <div class="col col-l box-2-con" style="top: -50px;">
                <div class="" style="width: 700px;">
                    <div class="line1"></div>
                    <h2 class="title2">
                        以科技助力
                        <br>会展企业创新发展
                    </h2>
                    <p class="txt1" style="margin-top: 35px;color: #333333;">会展供应链（ExpoSCM） 创⽴于2016年，作为⼀家专注
                        于中国会展产业数字化发展的国家级⾼新技术企业，是以
                        助⼒会展服务创新为使命，赋能⼩微会展企业数字化升级
                        的会展产业互联⽹综合服务平台。创⽴7年来，为全产业链
                        各合作伙伴创造了⼀个⼜⼀个适⽤于不同会展场景下的数
                        字化解决⽅案。</p>
                    <!-- <p class="txt1" style="margin-top: 10px;">公司历时5年，主场运营形成了以北京为核心的五地同时发展的服务体系，深耕20多个城市，与30多家展馆保持良好的合作氛围关系，共计服务展会100多场。</p> -->
                </div>
                <div class="list1" id="j-number" style="margin-top: 50px;">
                    <dl>
                        <dt><font class="timer" data-to="300" data-speed="1000" style="color: #333333;">300</font><span style="color: #333333;">+</span></dt>
                        <dd>服务展会场次</dd>
                    </dl>
                    <dl>
                        <dt><font class="timer" data-to="10000" data-speed="1000" style="color: #333333;">10000</font><span style="color: #333333;">+</span></dt>
                        <dd>累计报馆订单</dd>
                    </dl>
                    <dl>
                        <dt><font class="timer" data-to="100" data-speed="1000" style="color: #333333;">100</font><span style="color: #333333;">+</span></dt>
                        <dd>全国合作伙伴</dd>
                    </dl>
                    <dl>
                        <dt><font class="timer" data-to="20" data-speed="1000" style="color: #333333;">20</font><span style="color: #333333;">+</span></dt>
                        <dd>累计服务城市</dd>
                    </dl>
                </div>
            </div>
        </section>
        <section class="row" id="product">
            <div class="col box-4">
                <h2 class="title3" style="margin-bottom: 50px;color: #333333;">面向丰富业务场景的标准化云系统
                </h2>
                <div class="box-4-con">
                    <div>
                        <img src="../images/logo-3-1.svg" alt="">
                        <p class="p1" id="cp-title" style="color: #333333;">Work主场云</p>
                        <span class="span1" id="cp-msg">一体化线上管理，解决资料审核繁琐、信息传递差、项目收费乱、现场执行难等问题，降低综合运营成本。</span>
                    </div>
                    <!-- <h3 class="title2"></h3> -->
                    <a id="cp-url" class="a1" href="https://www.expopaas.com/articlework" target="_blank">了解详情</a>
                    <div class="btn-box">
                        <a id="prev" href="javascript:;"></a>
                        <span id="cp-index">1/8</span>
                        <a id="next" href="javascript:;"></a>
                    </div>
                </div>
                <div class="ban2-box">
                    <ul class="ban2-list" id="cp-img">
                        <li>
                            <img src="../images/img-cp1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp2.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp3.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp4.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp5.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp6.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp7.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp8.png" alt="">
                        </li>
                    </ul>
                    <!-- <div class="btn-box">
                        <a href="javascript:;"></a>
                        <span>1/2</span>
                        <a href="javascript:;"></a>
                    </div> -->
                </div>
            </div>
        </section>
        <div style="background: #fff;">

            <section class="row">
                <div class="col box-3">
                    <h2 class="title3" style="margin-bottom: 30px;color: #333333;">覆盖产业全境的数字化解决方案</h2>
                    <div class="list-jjfa">
                        <a href="solution" class="aniview">
                            <img src="../images/img-fa1.png" alt="">
                            <div>
                                <p>主承办企业解决方案</p>
                                <span>为主办企业/协会提供多元化、标准化、高性价比的高效办展解决方案。</span>
                            </div>
                        </a>
                        <a href="solution2" class="aniview">
                            <img src="../images/img-fa2.png" alt="">
                            <div>
                                <p>主场企业解决方案</p>
                                <span>为主场企业提供高效率、低成本、创新增收的数字化升级解决方案。</span>
                            </div>
                        </a>
                        <a href="solution3" class="aniview">
                            <img src="../images/img-fa3.png" alt="">
                            <div>
                                <p>展装企业解决方案</p>
                                <span>为展装企业提供全面高效、标准管理、资源共享的数字化升级解决方案。</span>
                            </div>
                        </a>
                        <a href="solution4" class="aniview">
                            <img src="../images/img-fa4.png" alt="">
                            <div>
                                <p>场馆企业解决方案</p>
                                <span>为会展场馆提供多元化、个性化、高性价比的数字化管理解决方案。</span>
                            </div>
                        </a>
                    </div>
                </div>
            </section>

            <section class="row" id="paas">
                <div class="col box-3">
                    <h2 class="title3" style="margin-bottom: 30px;color: #333333;">专业化、标准化、规范化的平台服务
                    </h2>
                    <div class="list3">
                        <a href="http://shop.exposcm.com/" class="li1" target="_blank">
                            <img class="img1" src="../images/img-ptfw1.png" alt="">
                            <img class="img2" src="../images/img-ptfw1x.png" alt="">
                            <div>
                                <div class="label">印刷服务</div>
                            </div>
                        </a>
                        <a href="http://design.exposaas.com" class="li2" target="_blank">
                            <img class="img1" src="../images/img-ptfw2.png" alt="">
                            <img class="img2" src="../images/img-ptfw2x.png" alt="">
                            <div>
                                <div class="label">设计与施⼯</div>
                            </div>
                        </a>
                        <a href="pass" class="li2">
                            <img class="img1" src="../images/img-ptfw3.png" alt="">
                            <img class="img2" src="../images/img-ptfw3x.png" alt="">
                            <div>
                                <div class="label">主场运营</div>
                            </div>
                        </a>
                        <a href="paas2" class="li2">
                            <img class="img1" src="../images/img-ptfw4.png" alt="">
                            <img class="img2" src="../images/img-ptfw4x.png" alt="">
                            <div>
                                <div class="label">商旅服务</div>
                            </div>
                        </a>
                        <!-- ./page/paas-3.html -->
                        <a href="javascript:;" class="li2">
                            <img class="img1" src="../images/img-ptfw5.png" alt="">
                            <img class="img2" src="../images/img-ptfw5x.png" alt="">
                            <div class="d2">
                                <div class="label">线上会展</div>
                            </div>
                        </a>
                    </div>
                    <!-- <ul class="list2">
                        <li>
                            <img src="../images/img-1.jpg" alt="">
                            <a href="javascript:;">
                                <span>会展商城</span>
                            </a>
                        </li>
                        <li>
                            <img src="../images/img-2.jpg" alt="">
                            <a href="javascript:;">
                                <span>主场服务</span>
                            </a>
                        </li>
                        <li>
                            <img src="../images/img-3.jpg" alt="">
                            <a href="javascript:;">
                                <span>线上会展</span>
                            </a>
                        </li>
                    </ul> -->
                </div>
            </section>

            <section class="row">
                <div class="col box-3">
                    <h2 class="title3" style="margin-bottom: 50px;color: #333333;">开放、创新、共赢的合作与生态</h2>
                    <div class="box-hzst">
                        <div class="div-l" style="align-items: normal;">
                            <p style="margin-right: 70px;">打破了传统会展固有模式的数字化全渠道合作，建⽴会展全产业数字⽣态圈。
                                加⼊我们，不论您是主办⽅、主场服务商、搭建服务商还是其他会展供应商。
                                让我们⼀起携⼿共赢！</p>
                            <a class="a1" href="cooperation">了解详情</a>
                        </div>
                        <div class="div-r">
                            <img src="../images/img-8.png" alt="">
                        </div>
                    </div>
                </div>
            </section>

            <section class="row">

                <div class="col " style="padding-top: 50px;">
                    <h2 class="title3" style="margin-bottom: 44px;color: #333333;">新闻动态</h2>
                    <div class="box-5 col-r " id="news-list" style="margin-bottom: 50px;">
                        <!-- <div class="box-5-item">
                            <div class="box-5-con">
                                <div class="time1"><span>1</span>/<span>2</span></div>
                                <p class="title4">商务部：持续优化政府服务，为展览业营造良好的发展环境。</p>
                            </div>
                        </div>
                        <div class="box-5-item">
                            <div class="box-5-con">
                                <div class="time1"><span>1</span>/<span>2</span></div>
                                <p class="title4">单体规模北京市最大 新国展二期将于年内开建</p>
                                <p class="txt1" style="margin-top: 12px;">北京市发改委核准新国展三期为配套服务功能，包括总规模超过100万平方米的酒店、写字楼、体验式商业、公寓等业态，预计2024年竣工投用。</p>
                            </div>
                        </div>
                        <div class="box-5-item">
                            <div class="box-5-con">
                                <div class="time1"><span>1</span>/<span>2</span></div>
                                <p class="title4">会展中心，将成为天津的“生态会客厅”。</p>
                            </div>
                        </div> -->
                    </div>
                </div>
            </section>
        </div>
    </div>
      <!-- 英文版 -->
      <div v-else class="index-main" id="index">
        <section class="ban">
            <div class="col">
                <div>
                    <h1 class="h1" style="font-size: 65px;">
                        Providing innovative digital intelligent cloud services for all key links in the exhibition industry chain
                    </h1>
                    <!-- <a class="btn" href="about">了解详情</a> -->
                    <!-- <div class="line"></div> -->
                </div>
            </div>
        </section>

        <section class="box-2">
            <!-- <div class="box-2-bg">
                <div class="bg-top"></div>
                <div class="bg-bottom"></div>
            </div> -->
            <div class="col col-l box-2-con" style="top: -50px;">
                <div class="" style="width: 900px;text-align: left;">
                    <!-- <div class="line1"></div> -->
                    <h2 class="title2"  style="color: #333333;text-align: left;font-size: 39px;">
                        Exhibition supply chain technology helps innovation
                    </h2>
                    <p class="txt1" style="margin-top: 35px;">
                        Exhibition Supply Chain is a national high-tech enterprise focusing on China's exhibition industry. The company's home operation business is committed to providing innovative exhibition and comprehensive security solutions for various types of exhibition activities at home and abroad.
                    </p>
                    <!-- <p class="txt1" style="margin-top: 10px;">公司历时5年，主场运营形成了以北京为核心的五地同时发展的服务体系，深耕20多个城市，与30多家展馆保持良好的合作氛围关系，共计服务展会100多场。</p> -->
                </div>
                <div class="list1" id="j-number" style="margin-top: 50px;">
                    <dl>
                        <dt><font class="timer" style="color: #333333;" data-to="300" data-speed="1000">300</font><span style="right: -10px;color: #333333;">+</span></dt>
                        <dd style="font-size: 14px;">Service exhibition venues</dd>
                    </dl>
                    <dl>
                        <dt><font class="timer" style="color: #333333;" data-to="21000" data-speed="1000">21000</font><span style="right: -30px;color: #333333;">+</span></dt>
                        <dd style="font-size: 14px;">Accumulated newspaper orders</dd>
                    </dl>
                    <dl>
                        <dt><font class="timer" style="color: #333333;" data-to="30" data-speed="1000">30</font><span style="right: 100px;color: #333333;">+</span></dt>
                        <dd style="font-size: 14px;">National cooperation exhibition hall</dd>
                    </dl>
                    <dl>
                        <dt><font class="timer" style="color: #333333;" data-to="20" data-speed="1000">20</font><span style="right: 30px;color: #333333;">+</span></dt>
                        <dd style="font-size: 14px;">Cumulative service cities</dd>
                    </dl>
                </div>
            </div>
        </section>
        <section class="row" id="product">
            <div class="col box-4">
                <h2 class="title3" style="margin-bottom: 50px;color: #333333;"> SAAS Product
                </h2>
                <div class="box-4-con">
                    <div>
                        <img src="../images/logo-3-1.svg" alt="">
                        <p class="p1" id="cp-title" style="color: #333333;">ExpoWork</p>
                        <span class="span1" id="cp-msg">Integrated online management solves problems such as cumbersome data review, poor information transmission, chaotic project charges, and difficult on-site execution, and reduces comprehensive operating costs.</span>
                    </div>
                    <!-- <h3 class="title2"></h3> -->
                    <a id="cp-url" class="a1" href="https://www.expopaas.com/articlework" target="_blank">Learn more</a>
                    <div class="btn-box">
                        <a id="prev" href="javascript:;"></a>
                        <span id="cp-index">1/8</span>
                        <a id="next" href="javascript:;"></a>
                    </div>
                </div>
                <div class="ban2-box">
                    <ul class="ban2-list" id="cp-img">
                        <li>
                            <img src="../images/img-cp1-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp2-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp3-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp4-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp5-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp6-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp7-1.png" alt="">
                        </li>
                        <li>
                            <img src="../images/img-cp8-1.png" alt="">
                        </li>
                    </ul>
                    <!-- <div class="btn-box">
                        <a href="javascript:;"></a>
                        <span>1/2</span>
                        <a href="javascript:;"></a>
                    </div> -->
                </div>
            </div>
        </section>
        <div style="background: #fff;">
            <section class="row" id="paas">
                <div class="col box-3">
                    <h2 class="title3" style="margin-bottom: 30px;color: #333333;">Platform service
                    </h2>
                    <div class="list3">
                        <a href="http://shop.exposcm.com/" class="li1" target="_blank">
                            <img class="img1" src="../images/img-ptfw1.png" alt="">
                            <img class="img2" src="../images/img-ptfw1x.png" alt="">
                            <div>
                                <div class="label" style="font-size: 18px;">Printing mall</div>
                            </div>
                        </a>
                        <a href="http://design.exposaas.com" class="li2" target="_blank">
                            <img class="img1" src="../images/img-ptfw2.png" alt="">
                            <img class="img2" src="../images/img-ptfw2x.png" alt="">
                            <div>
                                <div class="label" style="font-size: 18px;">Exhibition design mall</div>
                            </div>
                        </a>
                        <a href="paas" class="li2">
                            <img class="img1" src="../images/img-ptfw3.png" alt="">
                            <img class="img2" src="../images/img-ptfw3x.png" alt="">
                            <div>
                                <div class="label" style="font-size: 18px;">Home operation</div>
                            </div>
                        </a>
                        <a href="paas2" class="li2">
                            <img class="img1" src="../images/img-ptfw4.png" alt="">
                            <img class="img2" src="../images/img-ptfw4x.png" alt="">
                            <div>
                                <div class="label" style="font-size: 18px;">Business travel service</div>
                            </div>
                        </a>
                        <!-- ./page/paas-3.html -->
                        <a href="javascript:;" class="li2">
                            <img class="img1" src="../images/img-ptfw5.png" alt="">
                            <img class="img2" src="../images/img-ptfw5x.png" alt="">
                            <div class="d2">
                                <div class="label" style="font-size: 18px;">Online exhibition</div>
                            </div>
                        </a>
                    </div>
                    <!-- <ul class="list2">
                        <li>
                            <img src="../images/img-1.jpg" alt="">
                            <a href="javascript:;">
                                <span>会展商城</span>
                            </a>
                        </li>
                        <li>
                            <img src="../images/img-2.jpg" alt="">
                            <a href="javascript:;">
                                <span>主场服务</span>
                            </a>
                        </li>
                        <li>
                            <img src="../images/img-3.jpg" alt="">
                            <a href="javascript:;">
                                <span>线上会展</span>
                            </a>
                        </li>
                    </ul> -->
                </div>
            </section>

            <section class="row">
                <div class="col box-3">
                    <h2 class="title3" style="margin-bottom: 50px;">Cooperation and Ecology</h2>
                    <div class="box-hzst">
                        <div class="div-l">
                            <p>
                                Break the inherent model of traditional exhibition, based on the needs of core enterprises in the industrial chain, complete the integration of traditional exhibition business and "Internet +" technology, open up the channels of related industries through the digital products of the exclusive exhibition industry, and complete the upgrading goal of "extending the exhibition industry chain, expanding the scope of influence of exhibition, and improving the professional level of exhibition". Finally form a new driving force to promote the all-channel development of the exhibition industry.
                            </p>
                        </div>
                        <div class="div-r">
                            <img src="../images/img-8-1.png" alt="">
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
      <!-- 内容部分结束 -->

      <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
  </div>
</template>
<style>
.data-class .el-year-table td.today .cell { 
    font-weight: normal;
    color: #606266;
  }
  .data-class .el-year-table td.current .cell { 
    font-weight: normal;
    color: #409EFF !important;
  }
</style>
<script>
  import $ from 'jquery';
  import headers from '@/common/header';
  import footers from '@/common/Footer';
  import contact from '@/components/contact';
  export default {
    data() {
      
      return {
        langluageType:sessionStorage.getItem('langluageType')||'ch',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
        value6: ''
      }
    },
    components: {
      headers,
      footers,
      contact
    },
    mounted() {
      
      const target = document.querySelector('#j-number');
        // const tip = document.querySelector('.tip');
        const observe = new IntersectionObserver(entries => {
            for (const entry of entries) {
                console.log(entry,entry.isIntersecting)
                if(entry.isIntersecting){
                    $(".timer").each(count);
                    function count(a) {
                        var b = $(this);
                        a = $.extend({},
                        a || {},
                        b.data("countToOptions") || {});
                        b.countTo(a)
                    };
                }
                // tip.innerHTML = entry.isIntersecting ? '展示' : '隐藏';
            }
        });
        observe.observe(target);
        function formatDate (value) {
          let date = new Date(value);
          if(date == 'Invalid Date'){
              return ''
          }
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? ('0' + MM) : MM;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      };
        function num_add(id){
            var _e = $(id),
                _from = Number(_e.attr('data-from'))
                _to = Number(_e.attr('data-to'))
            // console.log(_from, _to)
            setTimeout(function() {
                var n = _from + (parseInt((_to-_from)/2)|| 1)
                console.log(n<=_to, n+'<='+_to)   
                if(n<=_to){
                    _e.text(n).attr('data-from', n)
                    num_add(id)
                }
            }, 50);
        }

        settHash()
        $('body')[0].onhashchange = function(){
            // console.log(e)
            // console.log(location.hash)
            settHash()
        };
        function settHash(){
            var hash = location.hash
            if(hash){
                var _class = hash.substr(1)
                $('#j-nav>li.'+_class).addClass('active').siblings().removeClass('active')
            }
            // console.log(hash,location.href)
            // $('#j-nav>a[href="'+hash+'"]').addClass('active').siblings().removeClass('active')
        }

        var cp_index = 0;
        var cp_list = null
        if(this.langluageType == 'ch'){
            cp_list = [
                {
                    title: 'Work主场云',
                    msg: '一体化线上管理，解决资料审核繁琐、信息传递差、项目收费乱、现场执行难等问题，降低综合运营成本。',
                    img: './images/img-cp1.png',
                    url: 'https://www.expopaas.com/articlework'
                },
                {
                    title: 'CRM招展云',
                    msg: '招展业务全流程实时线上管理，帮助规范销售流程管理、提升内部信息传递效率、准确掌握销售动态。',
                    img: './images/img-cp2.png',
                    url: 'https://www.expopaas.com/articlecrm'
                },
                {
                    title: 'Guest观众云',
                    msg: '解决传统业务模式中注册登记时间长、人员接触密集、现场体验差、数据管理难等问题。',
                    img: './images/img-cp3.png',
                    url: 'https://www.expopaas.com/articleguest'
                },
                {
                    title: 'Project展装云',
                    msg: '针对展装企业，解决传统业务模式中销售流程乱、客户粘性低、财务管控弱等问题，帮助提高综合项目收益。',
                    img: './images/img-cp4.png',
                    url: 'https://www.expopaas.com/articlepro'
                },
                {
                    title: 'Design设计云',
                    msg: '设计资源共享的线上平台，通过聚合效益，汇集存量设计资源，实现共享经济，降低企业综合设计成本。',
                    img: './images/img-cp5.png',
                    url: 'https://www.expopaas.com/articledesign'
                },
                {
                    title: 'CarGo物流云',
                    msg: '有效优化传统物流中申报体验差、办证时间长、动态信息慢、规范管理难、现场收费乱等问题。',
                    img: './images/img-cp6.png',
                    url: 'https://www.expopaas.com/articlecargo'
                },
                {
                    title: 'Hub场馆云',
                    msg: '解决传统模式中痕迹保存难、时段信息慢、流转效率低、现场执行难等问题，帮助规范销售流程管理。',
                    img: './images/img-cp7.png',
                    url: 'https://www.expopaas.com/articlehub'
                },
                {
                    title: 'A.I.智能云',
                    msg: '基于ExpoSCM全产业链大数据，借助人工智能（A.I.）提供个性化的数据整合、匹配、精准营销、智慧管理。',
                    img: './images/img-cp8.png',
                    url: 'https://www.expopaas.com/articleAi'
                }
            ]
        }else{
            cp_list = [
                {
                    title: 'ExpoWork',
                    msg: 'Integrated online management solves problems such as cumbersome data review, poor information transmission, chaotic project charges, and difficult on-site execution, and reduces comprehensive operating costs.',
                    img: './images/img-cp1-1.png',
                    url: 'https://www.expopaas.com/articlework'
                },
                {
                    title: 'ExpoCRM',
                    msg: 'Real-time online management of the whole process of the exhibition business, helping to standardise the management of the sales process, improve the efficiency of internal information transfer, and accurately grasp the sales dynamics.',
                    img: './images/img-cp2-1.png',
                    url: 'https://www.expopaas.com/articlecrm'
                },
                {
                    title: 'ExpoGuest',
                    msg: 'Solve the problems of long registration time, intensive personnel contact, poor on-site experience and difficult data management in the traditional business model.',
                    img: './images/img-cp3-1.png',
                    url: 'https://www.expopaas.com/articleguest'
                },
                {
                    title: 'ExpoProject',
                    msg: 'For exhibition enterprises, it solves the problems of chaotic sales process, low customer stickiness and weak financial control in the traditional business model, and helps to improve the comprehensive project income.',
                    img: './images/img-cp4-1.png',
                    url: 'https://www.expopaas.com/articlepro'
                },
                {
                    title: 'ExpoDesign',
                    msg: 'An online platform for design resource sharing, which brings together the stock of design resources through the aggregation of benefits, realises the sharing economy and reduces the comprehensive design costs of enterprises.',
                    img: './images/img-cp5-1.png',
                    url: 'https://www.expopaas.com/articledesign'
                },
                {
                    title: 'ExpoCarGo',
                    msg: 'Effectively optimise the traditional logistics in the declaration experience is poor, long time to do the certificate, dynamic information is slow, regulate the management is difficult, on-site charges chaotic and other issues.',
                    img: './images/img-cp6-1.png',
                    url: 'https://www.expopaas.com/articlecargo'
                },
                {
                    title: 'ExpoHub',
                    msg: 'Based on ExpoSCM whole industry chain big data, with the help of Artificial Intelligence (A.I.) to provide personalised data integration, matching, accurate marketing and intelligent management.',
                    img: './images/img-cp7-1.png',
                    url: 'https://www.expopaas.com/articlehub'
                },
                {
                    title: 'ExpoA.I.',
                    msg: 'Solve the traditional model of trace preservation is difficult, slow time period information, flow of low efficiency, on-site implementation is difficult and other issues to help standardise the sales process management.',
                    img: './images/img-cp8-1.png',
                    url: 'https://www.expopaas.com/articleAi'
                }
            ]
        }
        
        
        set_cp(0)
        setInterval(function(){
            cp_next()
        }, 5000);
        $('#next').on('click', function(){
            cp_next()
        })
        $('#prev').on('click', function(){
            cp_prev()
        })
        function cp_next(){
            cp_index++
            if(cp_index == 8){
                cp_index = 0
            }
            set_cp(cp_index)
        }
        function cp_prev(){
            cp_index--
            if(cp_index == -1){
                cp_index = 7
            }
            set_cp(cp_index)
        }
        

        function set_cp(index){
            var cp = cp_list[index]
            $('#cp-index').html(index+1+'/'+cp_list.length)
            $('#cp-title').html(cp.title)
            $('#cp-msg').html(cp.msg)
            $('#cp-img>li').eq(index).css({'opacity': 1}).siblings('li').css({'opacity': 0})
            $('#cp-url').attr('href', cp.url)
        }

        var _category = {
            '最新文章': 'news',
            '全部': 'all',
            '企业动态': 'qydt',
            '行业动态': 'hydt'
        }
        get_news2()
        function get_news2(){
            $.ajax({
                type: "get",
                url: "https://www.exposcm.com/home-api/api/v1/document/search", // "/huizhan.php/company/get_document_list",
                data: {
                    category: 'news', //qydt：企业动态 hydt：行业动态 all：全部 news 最新文章
                    pageNum: 1, // 页码
                    pageSize: 3
                },
                dataType: "json",
                success: function (res) {
                    // toast({ msg: res.msg })
                    if (res.status == 200) {
                        set_news2(res.data.list)

                    }else{

                    }
                }
            });
        }

        function set_news2(list){
            var html = ''
            for(var i=0,j=list.length; i<j; i++){
                var item = list[i]
                html += '<div class="box-5-item">'+
                            '<div class="box-5-con">'+
                                '<div class="time1" style="width:200px">'+formatDate(item.create_time*1000)+'</div>'+
                                '<a class="new-title" href="newsDetail?id='+item.id+'&type='+_category[item.category]+'">'+item.title+'</a>'+
                            '</div>'+
                        '</div>'
            }
            $('#news-list').html(html)
        }




        //设置计数
        $.fn.countTo = function (options) {
            options = options || {};
            return $(this).each(function () {
                //当前元素的选项
                var settings = $.extend({}, $.fn.countTo.defaults, {
                    from:            $(this).data('from'),
                    to:              $(this).data('to'),
                    speed:           $(this).data('speed'),
                    refreshInterval: $(this).data('refresh-interval'),
                    decimals:        $(this).data('decimals')
                }, options);
                //更新值
                var loops = Math.ceil(settings.speed / settings.refreshInterval),
                    increment = (settings.to - settings.from) / loops;
                //更改应用和变量
                var self = this,
                $self = $(this),
                loopCount = 0,
                value = settings.from,
                data = $self.data('countTo') || {};
                $self.data('countTo', data);
                //如果有间断，找到并清除
                if (data.interval) {
                    clearInterval(data.interval);
                };
                data.interval = setInterval(updateTimer, settings.refreshInterval);
                //初始化起始值
                render(value);
                function updateTimer() {
                    value += increment;
                    loopCount++;
                    render(value);
                    if (typeof(settings.onUpdate) == 'function') {
                        settings.onUpdate.call(self, value);
                    }
                    if (loopCount >= loops) {
                        //移出间隔
                        $self.removeData('countTo');
                        clearInterval(data.interval);
                        value = settings.to;
                        if (typeof(settings.onComplete) == 'function') {
                            settings.onComplete.call(self, value);
                        }
                    }
                }
                function render(value) {
                    var formattedValue = settings.formatter.call(self, value, settings);
                    $self.html(formattedValue);
                }
            });
        };
        $.fn.countTo.defaults={
            from:0,               //数字开始的值
            to:0,                 //数字结束的值
            speed:1000,           //设置步长的时间
            refreshInterval:100,  //隔间值
            decimals:0,           //显示小位数
            formatter: formatter, //渲染之前格式化
            onUpdate:null,        //每次更新前的回调方法
            onComplete:null       //完成更新的回调方法
        };
        function formatter(value, settings){
            return value.toFixed(settings.decimals);
        }
    },
    beforeDestroy () {},
    methods: {},
    computed:{},
  };
  

</script>
<style scoped>
.span1 {
    text-align: left !important;
}
</style>


// WEBPACK FOOTER //
// src/page/paas.vue